<template>
<div class="mn">

    <!-- ===== ШАПКА: обложка, логотип, полезное за столом ===== -->
    <header class="mn__head" :class="{ 'has-cover': cover }">
        <div v-if="cover" class="mn__cover">
            <img :src="cover" alt="" fetchpriority="high" decoding="async">
        </div>

        <div class="mn__id">
            <img v-if="vendor.logo" :src="vendor.logo" class="mn__logo" width="72" height="72" alt="">
            <div class="mn__id-txt">
                <h1 class="mn__title">{{ vendor.title }}</h1>
                <p v-if="vendor.address" class="mn__addr">{{ vendor.address }}</p>
            </div>
        </div>

        <ul class="mn__facts">
            <li v-if="status" class="fact" :class="status.open ? 'is-open' : 'is-closed'">
                <i class="fact__dot"></i>{{ status.text }}
            </li>
            <li v-if="wifi">
                <button class="fact fact--btn" @click="copyWifi">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
                        <path d="M2.5 9a14 14 0 0 1 19 0M5.5 12.5a9.5 9.5 0 0 1 13 0M8.6 15.8a5 5 0 0 1 6.8 0"/>
                        <circle cx="12" cy="19" r="1.1" fill="currentColor" stroke="none"/>
                    </svg>
                    <span class="y-num">{{ wifi }}</span>
                    <svg class="fact__copy" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round">
                        <rect x="8.5" y="8.5" width="11" height="11" rx="2.5"/><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"/>
                    </svg>
                </button>
            </li>
            <li v-if="+vendor.service > 0" class="fact">{{ $t('m_service', { n: vendor.service }) }}</li>
        </ul>
    </header>

    <!-- ===== АКЦИИ ===== -->
    <div v-if="sliders.length" class="mn__promo">
        <div class="mn__promo-track">
            <button v-for="(s, si) in sliders" :key="s.id" class="mn__promo-item y-petal"
                    :aria-label="s.title || ''" @click="selectSlider(s.id)">
                <img :src="s.image" :loading="si === 0 ? 'eager' : 'lazy'" :fetchpriority="si === 0 ? 'high' : null" decoding="async" alt="">
            </button>
        </div>
    </div>

    <div class="mn__layout">

    <!-- ===== ПЛАНШЕТ/ДЕСКТОП: все категории колонкой слева ===== -->
    <aside v-if="shownCategories.length" class="mn__rail">
        <nav class="mn__rail-nav" ref="rail" :aria-label="$t('m_nav_menu')">
            <button v-for="c in shownCategories" :key="c.id"
                    class="mn__rail-item" :class="{ 'is-active': c.id === activeCat }"
                    :aria-current="c.id === activeCat ? 'true' : null"
                    :data-cid="c.id" @click="goCategory(c.id)">
                <span class="mn__rail-name">{{ c.title }}</span>
                <span class="mn__rail-n y-num">{{ c.products.length }}</span>
            </button>
        </nav>
    </aside>

    <div class="mn__content">
    <!-- ===== ЛИПКАЯ ПАНЕЛЬ: поиск + категории ===== -->
    <div class="mn__bar" ref="bar">
        <div class="mn__wrap">
            <label class="mn__search">
                <svg class="mn__search-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5" stroke-linecap="round"/>
                </svg>
                <input v-model="query" type="search" class="mn__search-input" enterkeyhint="search"
                       :placeholder="$t('word159')" :aria-label="$t('word159')" autocomplete="off" spellcheck="false">
                <button v-if="query" class="mn__search-clear" @click="query = ''" :aria-label="$t('m_clear')">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
                        <path d="M7 17L17 7M7 7l10 10"/>
                    </svg>
                </button>
            </label>
        </div>

        <nav v-show="!query" class="mn__chips" ref="chips">
            <button v-for="c in categoriesNav" :key="c.id"
                    class="mn__chip" :class="{ 'is-active': c.id === activeCat }"
                    :aria-current="c.id === activeCat ? 'true' : null"
                    :data-cid="c.id" @click="goCategory(c.id)">{{ c.title }}</button>
        </nav>
    </div>

    <!-- ===== БЛЮДА ===== -->
    <main class="mn__wrap mn__body">
        <p v-if="query && foundCount" class="mn__found">{{ $t('word160', { n: foundCount }) }}</p>

        <section v-for="(c, ci) in shownCategories" :key="c.id" :id="'n' + c.id" class="mn__cat">
            <h2 class="mn__cat-title">{{ c.title }}<span class="y-num">{{ c.products.length }}</span></h2>

            <ul class="mn__grid">
                <li v-for="(p, pi) in c.products" :key="p.id">
                    <article class="dish" :class="{ 'dish--off': p.stoplist, 'dish--in': qty(p.id) }">
                        <button class="dish__open" @click="selectProduct(p.id)">
                            <span class="dish__media y-petal">
                                <img class="dish__img"
                                     :src="p.image_min"
                                     :srcset="dishSrcset(p)"
                                     sizes="(max-width: 640px) 46vw, (max-width: 900px) 31vw, 270px"
                                     width="300" height="300"
                                     :loading="ci === 0 && pi < 4 ? 'eager' : 'lazy'"
                                     :fetchpriority="ci === 0 && pi < 2 ? 'high' : null"
                                     decoding="async" :alt="p.title">
                                <span v-if="p.stoplist" class="dish__off">{{ $t('word29') }}</span>
                                <span v-else-if="qty(p.id)" class="dish__qty y-num">× {{ qty(p.id) }}</span>
                            </span>
                            <span class="dish__name">{{ p.title }}</span>
                            <span v-if="showDesc(p)" class="dish__desc">{{ p.description }}</span>
                        </button>
                        <div class="dish__foot">
                            <span class="dish__price y-num">
                                <b dir="ltr">{{ p.show_price }}<small>{{ vendor.currency }}</small></b>
                                <em v-if="vendor.dollar && vendor.exchange" dir="ltr">≈ {{ (p.price / vendor.exchange).toFixed(2) }} $</em>
                            </span>
                            <button v-if="!p.stoplist" class="dish__add"
                                    :aria-label="(p.sizes && p.sizes.length ? $t('m_choose_size') : $t('m_add')) + ': ' + p.title"
                                    @click="quickAdd(p)">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5.5v13M5.5 12h13"/></svg>
                            </button>
                        </div>
                    </article>
                </li>
            </ul>
        </section>

        <div v-if="query && !shownCategories.length" class="mn__empty">
            <p>{{ $t('word161') }}</p>
            <p class="mn__empty-q">«{{ query }}»</p>
            <button class="y-btn-ghost y-petal-sm" @click="query = ''">{{ $t('m_clear') }}</button>
        </div>
    </main>
    </div>
    </div>

    <footer class="mn__foot">
        <a href="https://yola.menu" class="mn__foot-brand"><img src="@/assets/fav.png" width="20" height="20" alt="">Yola Menu</a>
        <span>{{ $t('word143') }} <a href="https://instagram.com/yola.menu">{{ $t('word144') }}</a></span>
    </footer>


    <transition name="toast">
        <div v-if="toast" class="mn__toast" role="status">{{ toast }}</div>
    </transition>

    <NavigatorNew />
</div>
</template>

<script>
import NavigatorNew from '@/components/NavigatorNew.vue'
import { dishSrcset } from '@/imageWidth'

const toMin = (t) => { const [h, m] = String(t).split(':'); return +h * 60 + +m }
const hhmm = (t) => String(t).slice(0, 5)

export default {
    components: { NavigatorNew },

    data() {
        return { query: '', activeCat: null, observer: null, toast: '', toastTimer: null }
    },

    computed: {
        vendor()        { return this.$store.state.vendor },
        sliders()       { return this.$store.state.sliders },
        categories()    { return this.$store.state.categories },
        categoriesNav() { return this.$store.state.categories_nav },

        // первое фото из галереи заведения — обложка
        cover() { return (this.vendor.images && this.vendor.images[0]) || '' },

        // в базе пустой пароль иногда хранится строкой "null"
        wifi() {
            const w = (this.vendor.wifi || '').trim()
            return w && !['null', 'none', 'undefined'].includes(w.toLowerCase()) ? w : ''
        },

        // открыто ли сейчас — по времени телефона гостя (он в том же городе)
        status() {
            const days = this.vendor.workdays || []
            if (!days.length) return null
            const now = new Date()
            const dow = now.getDay() || 7                       // API: 1 = пн … 7 = вс
            const mins = now.getHours() * 60 + now.getMinutes()
            const day = (n) => days.find(d => +d.day === n)
            const today = day(dow)
            const yesterday = day(dow === 1 ? 7 : dow - 1)

            // вчерашняя смена, перешедшая за полночь (например 12:00–01:00)
            if (yesterday && yesterday.work && yesterday.open && yesterday.close) {
                const o = toMin(yesterday.open), c = toMin(yesterday.close)
                if (c < o && mins < c) return { open: true, text: this.$t('m_open_until', { time: hhmm(yesterday.close) }) }
            }
            if (!today || !today.work || !today.open || !today.close) {
                return { open: false, text: this.$t('m_day_off') }
            }
            const o = toMin(today.open), c = toMin(today.close)
            if (o === c) return { open: true, text: this.$t('m_open_24') }
            const isOpen = c > o ? (mins >= o && mins < c) : (mins >= o || mins < c)
            if (isOpen) return { open: true, text: this.$t('m_open_until', { time: hhmm(today.close) }) }
            if (mins < o) return { open: false, text: this.$t('m_closed_until', { time: hhmm(today.open) }) }
            return { open: false, text: this.$t('m_closed') }
        },

        // поиск по названию и описанию; пустые категории отбрасываются
        shownCategories() {
            const q = this.query.trim().toLowerCase()
            if (!q) return this.categories
            return this.categories
                .map(c => ({
                    ...c,
                    products: c.products.filter(p =>
                        (p.title || '').toLowerCase().includes(q) ||
                        (p.description || '').toLowerCase().includes(q))
                }))
                .filter(c => c.products.length)
        },

        foundCount() {
            return this.shownCategories.reduce((n, c) => n + c.products.length, 0)
        },

        // сколько штук блюда (всех размеров) уже в корзине
        cartQty() {
            const m = {}
            for (const it of this.$store.state.cart) m[it.id] = (m[it.id] || 0) + it.quantity
            return m
        },
    },

    watch: {
        // категории приходят из API уже после mounted, а поиск меняет состав секций
        shownCategories() { this.$nextTick(this.watchSections) },
    },

    mounted() {
        const y = localStorage.getItem('scroll_new')
        if (y) window.scrollTo({ top: +y, behavior: 'instant' })
        this.$nextTick(this.watchSections)
    },

    beforeUnmount() {
        if (this.observer) this.observer.disconnect()
        clearTimeout(this.toastTimer)
    },

    methods: {
        // описание часто дублирует название — тогда не показываем
        showDesc(p) {
            const d = (p.description || '').trim()
            return d && d.toLowerCase() !== (p.title || '').trim().toLowerCase()
        },

        // подсветка активной категории по мере прокрутки
        watchSections() {
            if (!('IntersectionObserver' in window)) return
            if (this.observer) this.observer.disconnect()
            const sections = this.$el.querySelectorAll('.mn__cat')
            if (!sections.length) return

            this.observer = new IntersectionObserver(entries => {
                const vis = entries.filter(e => e.isIntersecting)
                if (!vis.length) return
                vis.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)
                const id = +vis[0].target.id.slice(1)
                if (id !== this.activeCat) {
                    this.activeCat = id
                    this.scrollChipIntoView(id)
                }
            }, { rootMargin: '-150px 0px -65% 0px', threshold: 0 })

            sections.forEach(el => this.observer.observe(el))
            if (this.activeCat === null && this.categoriesNav.length) this.activeCat = this.categoriesNav[0].id
        },

        // прокручиваем только ленту категорий (или колонку на планшете), не всю страницу
        scrollChipIntoView(id) {
            const sel = '[data-cid="' + id + '"]'
            const row = this.$refs.chips
            const chip = row && row.querySelector(sel)
            if (chip && row.offsetParent) {
                row.scrollTo({ left: chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2, behavior: 'smooth' })
            }
            const rail = this.$refs.rail
            const item = rail && rail.querySelector(sel)
            if (item && rail.offsetParent && rail.scrollHeight > rail.clientHeight) {
                rail.scrollTo({ top: item.offsetTop - (rail.clientHeight - item.offsetHeight) / 2, behavior: 'smooth' })
            }
        },

        goCategory(id) {
            const el = document.getElementById('n' + id)
            if (!el) return
            const bar = this.$refs.bar ? this.$refs.bar.offsetHeight : 0
            window.scrollTo({ top: window.pageYOffset + el.getBoundingClientRect().top - bar - 4, behavior: 'smooth' })
        },

        async copyWifi() {
            try {
                await navigator.clipboard.writeText(this.wifi)
            } catch (e) {
                // старые браузеры / http: копируем через скрытое поле
                const t = document.createElement('textarea')
                t.value = this.wifi; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'
                document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove()
            }
            this.showToast(this.$t('m_wifi_copied'))
        },

        dishSrcset,
        qty(id) { return this.cartQty[id] || 0 },

        // «+» на карточке: блюдо без размеров — сразу в корзину, с размерами — на страницу выбора
        quickAdd(p) {
            if (p.sizes && p.sizes.length) return this.selectProduct(p.id)
            this.$store.commit('setCurrentProduct', p.id)
            this.$store.state.product_size = { id: p.id, size: 0, title: p.title, price: p.price, show_price: p.show_price }
            if (this.$store.getters.cartDetailQuantity) this.$store.commit('productPlusQuantity')
            else this.$store.commit('productAddQuantity')
            this.showToast(this.$t('m_added'))
            if (navigator.vibrate) navigator.vibrate(10)
        },

        showToast(text) {
            this.toast = text
            clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = '' }, 2200)
        },

        selectSlider(id) {
            this.$store.commit('setCurrentSlider', id)
            this.$router.push({ name: 'slider', params: { slider: id } })
        },

        selectProduct(id) {
            localStorage.setItem('scroll_new', window.pageYOffset)
            this.$store.commit('setCurrentProduct', id)
            this.$router.push({ name: 'product', params: { product: id } })
            this.$store.state.product_size = {
                id,
                size: 0,
                title: this.$store.state.product.title,
                price: this.$store.state.product.price,
                show_price: this.$store.state.product.show_price,
            }
        },
    },
}
</script>

<style scoped>
.mn {
    min-height: 100vh; padding-bottom: calc(92px + env(safe-area-inset-bottom, 0px));
    background: var(--y-mist);
}
.mn__wrap, .mn__id, .mn__facts, .mn__promo-track, .mn__foot {
    max-width: 1120px; margin-inline: auto; padding-inline: 16px;
}
@media (min-width: 768px) {
    .mn__wrap, .mn__id, .mn__facts, .mn__promo-track, .mn__foot { padding-inline: 28px; }
}

/* ---------- шапка: белый блок с обложкой ---------- */
.mn__head {
    background: var(--y-paper); padding-top: 18px; padding-bottom: 18px;
    border-radius: 0 0 28px 28px; box-shadow: 0 1px 0 var(--y-line);
}
.mn__head.has-cover { padding-top: 0; }

.mn__cover { position: relative; max-width: 1120px; margin-inline: auto; overflow: hidden; }
.mn__cover img { display: block; width: 100%; aspect-ratio: 16 / 9; max-height: 320px; object-fit: cover; background: var(--y-mist); }
/* мягкое затемнение снизу — логотип и шапка читаются на любой фотографии */
.mn__cover::after {
    content: ''; position: absolute; inset: auto 0 0 0; height: 45%;
    background: linear-gradient(to top, rgba(29, 34, 48, .38), rgba(29, 34, 48, 0));
    pointer-events: none;
}
@media (min-width: 768px) {
    .mn__cover { padding: 16px 28px 0; }
    .mn__cover img { border-radius: 24px; }
    .mn__cover::after { display: none; }
}

.mn__id { display: flex; align-items: flex-end; gap: 14px; }
.has-cover .mn__id { margin-top: -34px; position: relative; z-index: 1; }
.mn__logo {
    flex: none; width: 76px; height: 76px; object-fit: cover; background: #fff;
    border-start-start-radius: 22px; border-start-end-radius: 22px;
    border-end-end-radius: 22px; border-end-start-radius: 6px;
    box-shadow: 0 0 0 3px #fff, 0 6px 18px rgba(29, 34, 48, .16);
}
.mn__id-txt { min-width: 0; padding-bottom: 2px; }
.has-cover .mn__id-txt { padding-top: 38px; }
.mn__title {
    font-size: 1.5rem; line-height: 1.15; font-weight: 750; letter-spacing: -.025em;
    color: var(--y-ink); overflow-wrap: anywhere;
}
.mn__addr { display: flex; align-items: center; gap: 4px; margin-top: 4px; font-size: .875rem; line-height: 1.35; color: var(--y-ink-3); }
@media (min-width: 768px) { .mn__title { font-size: 2rem; } }

.mn__facts { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px; list-style: none; }
.fact {
    display: inline-flex; align-items: center; gap: 7px; height: 34px; padding: 0 13px;
    border-radius: 999px; background: var(--y-mist);
    font-size: .8125rem; font-weight: 600; color: var(--y-ink-2); white-space: nowrap;
}
.fact svg { width: 16px; height: 16px; flex: none; }
.fact__dot { width: 8px; height: 8px; border-radius: 50%; background: currentColor; box-shadow: 0 0 0 3px rgba(15, 122, 64, .15); }
.fact.is-open   { color: var(--y-open); background: #e8f5ee; }
.fact.is-closed { color: var(--y-closed); background: #fdf0ee; }
.fact.is-closed .fact__dot { box-shadow: 0 0 0 3px rgba(180, 35, 24, .14); }
.fact--btn { border: 0; cursor: pointer; color: var(--y-ink); }
.fact--btn:active { background: #e9ebf0; }
.fact__copy { color: var(--y-ink-3); }

/* ---------- акции ---------- */
.mn__promo { margin-top: 18px; }
.mn__promo-track {
    display: flex; gap: 12px; overflow-x: auto; scroll-snap-type: x mandatory;
    scroll-padding-inline: 16px; scrollbar-width: none; padding-bottom: 4px;
}
.mn__promo-track::-webkit-scrollbar { display: none; }
.mn__promo-item {
    flex: 0 0 84%; scroll-snap-align: start; border: 0; padding: 0; overflow: hidden;
    cursor: pointer; background: var(--y-paper); box-shadow: 0 4px 14px rgba(29, 34, 48, .08);
}
.mn__promo-item:only-child { flex-basis: 100%; }
.mn__promo-item img { display: block; width: 100%; aspect-ratio: 16 / 9; object-fit: cover; }
@media (min-width: 768px)  { .mn__promo-item { flex-basis: 48%; } }
@media (min-width: 1024px) { .mn__promo-item { flex-basis: 32%; } }

/* ---------- липкая панель: поиск + категории ---------- */
.mn__bar {
    position: sticky; top: 0; z-index: 20; margin-top: 16px; padding-top: 10px;
    background: rgba(244, 245, 248, .9);
    backdrop-filter: saturate(180%) blur(16px); -webkit-backdrop-filter: saturate(180%) blur(16px);
}
.mn__search { position: relative; display: flex; align-items: center; }
.mn__search-ico { position: absolute; inset-inline-start: 15px; width: 18px; height: 18px; color: var(--y-ink-3); pointer-events: none; }
.mn__search-input {
    width: 100%; height: 46px; padding-inline: 44px 44px; border: 0; border-radius: 14px;
    background: var(--y-paper); color: var(--y-ink); font-size: 16px; outline: none;
    box-shadow: 0 1px 2px rgba(29, 34, 48, .05), inset 0 0 0 1px var(--y-line);
    transition: box-shadow .15s;
}
.mn__search-input::placeholder { color: var(--y-ink-3); }
.mn__search-input:focus { box-shadow: inset 0 0 0 1.5px var(--y-ink); }
.mn__search-input::-webkit-search-cancel-button { display: none; }
.mn__search-clear {
    position: absolute; inset-inline-end: 9px; width: 28px; height: 28px; padding: 5px;
    border: 0; border-radius: 50%; background: var(--y-mist); color: var(--y-ink-2); cursor: pointer;
}

.mn__chips {
    display: flex; gap: 6px; overflow-x: auto; scrollbar-width: none;
    max-width: 1120px; margin-inline: auto; padding: 10px 16px 12px;
}
.mn__chips::-webkit-scrollbar { display: none; }
@media (min-width: 768px) { .mn__chips { padding-inline: 28px; } }
.mn__chip {
    flex: none; height: 38px; padding: 0 15px; border: 0; border-radius: 999px;
    background: var(--y-paper); color: var(--y-ink-2); box-shadow: inset 0 0 0 1px var(--y-line);
    font-size: .875rem; font-weight: 500; white-space: nowrap; cursor: pointer;
    transition: background-color .2s, color .2s, border-radius .2s, box-shadow .2s;
}
.mn__chip:active { background: #eceef3; }
/* активная категория — «лепесток» из логотипа */
.mn__chip.is-active {
    background: var(--y-ink); color: #fff; font-weight: 600; box-shadow: none;
    border-start-start-radius: 19px; border-start-end-radius: 19px;
    border-end-end-radius: 19px; border-end-start-radius: 5px;
}

/* ---------- планшет в альбомной ориентации и шире: категории колонкой слева ---------- */
.mn__rail { display: none; }
@media (min-width: 900px) {
    .mn__layout {
        display: grid; grid-template-columns: 216px minmax(0, 1fr); gap: 28px; align-items: start;
        max-width: 1120px; margin: 16px auto 0; padding-inline: 28px;
    }
    .mn__content .mn__wrap { max-width: none; padding-inline: 0; }
    .mn__bar { margin-top: 0; padding-bottom: 12px; }
    .mn__chips { display: none; }

    .mn__rail {
        display: block; position: sticky; top: 10px;
        max-height: calc(100vh - 20px - 80px - env(safe-area-inset-bottom, 0px));
        overflow-y: auto; overscroll-behavior: contain; scrollbar-width: thin;
        border-radius: 20px;
    }
    .mn__rail-nav {
        position: relative; display: flex; flex-direction: column; gap: 2px; padding: 6px;
        background: var(--y-paper); border-radius: 20px;
        box-shadow: 0 1px 2px rgba(29, 34, 48, .04), 0 6px 18px rgba(29, 34, 48, .06);
    }
    .mn__rail-item {
        display: flex; align-items: center; justify-content: space-between; gap: 10px;
        width: 100%; min-height: 46px; padding: 10px 12px; border: 0; border-radius: 14px;
        background: none; color: var(--y-ink-2); text-align: start; cursor: pointer;
        font-size: .9375rem; line-height: 1.25; font-weight: 500;
        transition: background-color .15s, color .15s;
    }
    .mn__rail-name { min-width: 0; overflow-wrap: anywhere; }
    .mn__rail-n { flex: none; font-size: .75rem; font-weight: 600; color: var(--y-ink-3); }
    .mn__rail-item:active { background: var(--y-mist); }
    /* активная категория — тот же «лепесток», что у чипса на телефоне */
    .mn__rail-item.is-active {
        background: var(--y-ink); color: #fff; font-weight: 600;
        border-start-start-radius: 16px; border-start-end-radius: 16px;
        border-end-end-radius: 16px; border-end-start-radius: 5px;
    }
    .mn__rail-item.is-active .mn__rail-n { color: rgba(255, 255, 255, .7); }
}
@media (min-width: 900px) and (hover: hover) {
    .mn__rail-item:not(.is-active):hover { background: var(--y-mist); color: var(--y-ink); }
}
/* альбомный планшет: экран низкий — обложка ниже, блюда видны сразу */
@media (min-width: 900px) and (max-height: 900px) {
    .mn__cover img { max-height: min(320px, 34vh); }
}

/* ---------- блюда ---------- */
.mn__body { padding-top: 4px; }
.mn__found { padding-top: 14px; font-size: .875rem; color: var(--y-ink-3); }
.mn__cat { padding-top: 24px; scroll-margin-top: 160px; }
.mn__cat-title {
    display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
    font-size: 1.3125rem; line-height: 1.2; font-weight: 750; letter-spacing: -.02em;
}
.mn__cat-title span {
    min-width: 26px; height: 24px; padding: 0 8px; border-radius: 999px; display: inline-grid; place-items: center;
    background: #e7e9ef; font-size: .75rem; font-weight: 600; color: var(--y-ink-2);
}
@media (min-width: 768px) { .mn__cat-title { font-size: 1.5rem; } }

.mn__grid {
    display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px; list-style: none; padding: 0; margin: 0;
}
/* с колонкой категорий на широком экране остаётся 3 карточки в ряд — фото крупнее */
@media (min-width: 640px)  { .mn__grid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; } }
@media (min-width: 900px)  { .mn__grid { gap: 18px; } }
.mn__grid > li { display: flex; }

.dish {
    position: relative; display: flex; flex-direction: column; width: 100%;
    padding: 6px; background: var(--y-paper); border-radius: 22px;
    box-shadow: 0 1px 2px rgba(29, 34, 48, .04), 0 6px 18px rgba(29, 34, 48, .06);
    transition: box-shadow .2s, transform .2s var(--y-ease);
}
.dish.dish--in { box-shadow: 0 0 0 2px var(--y-anor), 0 6px 18px rgba(215, 38, 61, .12); }
@media (hover: hover) {
    .dish:hover { box-shadow: 0 2px 4px rgba(29, 34, 48, .05), 0 14px 30px rgba(29, 34, 48, .10); }
    .dish:hover .dish__img { transform: scale(1.04); }
}
.dish__open {
    display: flex; flex-direction: column; flex: 1; width: 100%; padding: 0;
    border: 0; background: none; text-align: start; cursor: pointer; color: inherit;
}
.dish__open:active .dish__img { transform: scale(.97); }
.dish__media { position: relative; display: block; overflow: hidden; background: var(--y-mist); }
.dish__img { display: block; width: 100%; aspect-ratio: 1 / 1; object-fit: cover; transition: transform .35s var(--y-ease); }
.dish--off .dish__img { filter: grayscale(1); opacity: .5; }
.dish__off, .dish__qty {
    position: absolute; inset-inline-start: 8px; bottom: 8px; padding: 4px 9px; border-radius: 9px;
    font-size: .6875rem; font-weight: 700;
}
.dish__off { background: rgba(29, 34, 48, .86); color: #fff; }
.dish__qty { background: var(--y-anor); color: #fff; }

.dish__name {
    margin: 10px 6px 0; font-size: .9375rem; line-height: 1.3; font-weight: 650; color: var(--y-ink);
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.dish__desc {
    margin: 3px 6px 0; font-size: .8125rem; line-height: 1.35; color: var(--y-ink-3);
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.dish__foot { display: flex; align-items: flex-end; justify-content: space-between; gap: 8px; margin-top: auto; padding: 10px 2px 2px 6px; }
.dish__price { display: flex; flex-direction: column; min-width: 0; }
.dish__price b { font-size: 1.0625rem; font-weight: 750; letter-spacing: -.015em; color: var(--y-ink); white-space: nowrap; }
.dish__price small { margin-inline-start: 4px; font-size: .6875rem; font-weight: 600; color: var(--y-ink-3); }
.dish__price em { font-style: normal; font-size: .75rem; color: var(--y-ink-3); }
.dish--off .dish__name, .dish--off .dish__price b { color: var(--y-ink-3); }

/* «+» — главное действие гостя, поэтому гранатовый */
.dish__add {
    flex: none; width: 38px; height: 38px; display: grid; place-items: center; padding: 0;
    border: 0; cursor: pointer; color: #fff; background: var(--y-anor);
    border-start-start-radius: 14px; border-start-end-radius: 14px; border-end-end-radius: 14px; border-end-start-radius: 4px;
    box-shadow: 0 4px 10px rgba(215, 38, 61, .28); transition: transform .15s var(--y-ease), background-color .15s;
}
.dish__add svg { width: 20px; height: 20px; }
.dish__add:active { transform: scale(.9); background: var(--y-anor-deep); }

@media (min-width: 768px) { .dish__name { font-size: 1rem; } }

/* ---------- пусто / подвал ---------- */
.mn__empty { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 64px 16px; text-align: center; }
.mn__empty p { font-size: 1rem; font-weight: 600; }
.mn__empty-q { color: var(--y-ink-3); font-weight: 500 !important; margin-bottom: 14px; overflow-wrap: anywhere; }

.mn__foot {
    display: flex; flex-direction: column; align-items: center; gap: 6px;
    margin-top: 40px; padding-top: 20px; padding-bottom: 8px; text-align: center;
    font-size: .8125rem; color: var(--y-ink-3);
}
.mn__foot-brand { display: inline-flex; align-items: center; gap: 6px; font-weight: 600; color: var(--y-ink-2); }
.mn__foot a:not(.mn__foot-brand) { color: var(--y-petal); }

/* ---------- тост ---------- */
.mn__toast {
    position: fixed; left: 50%; bottom: calc(88px + env(safe-area-inset-bottom, 0px)); z-index: 50;
    transform: translateX(-50%); max-width: calc(100% - 32px);
    padding: 11px 16px; border-radius: 14px; background: var(--y-ink); color: #fff;
    font-size: .875rem; font-weight: 600; box-shadow: var(--y-shadow-pop);
}
.toast-enter-active, .toast-leave-active { transition: opacity .2s, transform .25s var(--y-ease); }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translate(-50%, 8px); }
</style>
